var _path, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStripeLogoOk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 5.5C0.5 4.39543 1.39543 3.5 2.5 3.5H17.5C18.6046 3.5 19.5 4.39543 19.5 5.5V20.5C19.5 21.6046 18.6046 22.5 17.5 22.5H2.5C1.39543 22.5 0.5 21.6046 0.5 20.5V5.5Z",
    fill: "#635BFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.97152 10.2179C8.97152 9.68411 9.40861 9.47616 10.1384 9.47616C11.1808 9.47616 12.4974 9.79271 13.5397 10.3556V7.12914C12.402 6.67881 11.2762 6.5 10.1384 6.5C7.35033 6.5 5.5 7.9543 5.5 10.3848C5.5 14.1728 10.7132 13.5689 10.7132 15.202C10.7132 15.8311 10.1636 16.0391 9.39669 16.0391C8.25894 16.0391 6.80331 15.5728 5.64967 14.9397V18.2073C6.92517 18.757 8.21656 18.9901 9.39669 18.9901C12.251 18.9901 14.2113 17.5742 14.2113 15.1185C14.198 11.0272 8.97152 11.7556 8.97152 10.2179Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 4.5,
    r: 3.5,
    fill: "#2DB98D",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStripeLogoOk);
export default __webpack_public_path__ + "static/media/stripe-logo-ok.904d58c7e544f65d721e727e3edebba4.svg";
export { ForwardRef as ReactComponent };